// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"101":"d716cab9","638":"b4bc721f"}[chunkId] + ".chunk.css";
};